import React from 'react';
import {
  Modal,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';

import {WEB_APP_BASE_URL} from 'config/app.config';
import {hideQuotaPaywall} from 'store/subscriptionUi';

const meterLabel = meter => {
  if (meter === 'course') return 'course-generation';
  if (meter === 'text') return 'text-tutor';
  return 'voice-tutor';
};

export default function WebQuotaPaywall() {
  const dispatch = useDispatch();
  const visible = useSelector(state => Boolean(state.subscriptionUi?.visible));
  const exhausted = useSelector(state => state.subscriptionUi?.exhausted || {});

  const close = () => dispatch(hideQuotaPaywall());
  const viewPlans = () => {
    const destination = `${WEB_APP_BASE_URL}/settings?tab=subscription`;
    close();
    if (typeof window === 'undefined') return;
    try {
      window.top.location.assign(destination);
    } catch (_) {
      window.location.assign(destination);
    }
  };

  return (
    <Modal visible={visible} transparent animationType="fade" onRequestClose={close}>
      <View style={styles.backdrop}>
        <View style={styles.card}>
          <Text style={styles.eyebrow}>USAGE LIMIT REACHED</Text>
          <Text style={styles.title}>Your {meterLabel(exhausted.meter)} allowance is used</Text>
          <Text style={styles.body}>
            {exhausted.message || 'Choose a higher plan to continue, or wait for your allowance to reset.'}
          </Text>
          {exhausted.resetAt ? (
            <Text style={styles.reset}>Resets {new Date(exhausted.resetAt).toLocaleDateString()}</Text>
          ) : null}
          <View style={styles.actions}>
            <TouchableOpacity style={styles.secondaryButton} onPress={close}>
              <Text style={styles.secondaryText}>Not now</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.primaryButton} onPress={viewPlans}>
              <Text style={styles.primaryText}>View plans</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  backdrop: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
    backgroundColor: 'rgba(3, 6, 14, 0.82)',
  },
  card: {
    width: '100%',
    maxWidth: 440,
    padding: 28,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: 'rgba(197, 232, 54, 0.42)',
    backgroundColor: '#10151F',
  },
  eyebrow: {
    color: '#C5E836',
    fontSize: 12,
    fontWeight: '800',
    letterSpacing: 1.2,
  },
  title: {
    marginTop: 10,
    color: '#F6FBFF',
    fontSize: 24,
    lineHeight: 30,
    fontWeight: '800',
  },
  body: {
    marginTop: 12,
    color: 'rgba(246,251,255,0.72)',
    fontSize: 15,
    lineHeight: 22,
  },
  reset: {
    marginTop: 12,
    color: 'rgba(246,251,255,0.9)',
    fontSize: 13,
    fontWeight: '600',
  },
  actions: {
    marginTop: 24,
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  secondaryButton: {
    paddingVertical: 11,
    paddingHorizontal: 18,
    marginRight: 10,
    borderRadius: 10,
    backgroundColor: 'rgba(255,255,255,0.08)',
  },
  secondaryText: {color: '#F6FBFF', fontWeight: '700'},
  primaryButton: {
    paddingVertical: 11,
    paddingHorizontal: 18,
    borderRadius: 10,
    backgroundColor: '#C5E836',
  },
  primaryText: {color: '#10151F', fontWeight: '800'},
});
